import { chargingPointStatusUtils } from '@/utils/chargingPointStatus'

import ChargingPointScreenTemplate from './template/ChargingPointScreenTemplate'
import { ChargingPointScreenProps } from './types'

import ChargingSessionBody from '../components/ChargingSessionBody'

const UnavailableChargingPointScreen: React.FC<ChargingPointScreenProps> = (props) => {
  return (
    <ChargingPointScreenTemplate
      {...props}
      Body={
        <ChargingSessionBody
          message={
            <>
              Carregador <b style={{ color: chargingPointStatusUtils.getColorValue('UNAVAILABLE') }}>indisponível</b> no
              momento.
            </>
          }
        />
      }
    />
  )
}

export default UnavailableChargingPointScreen
